import Vue from 'vue'
import App from './components/App'
import router from './router'
import store from './store'

new Vue({
  el: '#app',
  router,
  render: h => h(App),
  store,
  created() {
    let el = document.getElementById('splash')
    el.parentNode.removeChild(el)
  },
})

/*
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('SW registered: ', registration)
    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError)
    })
  })
}
*/
